import { StyleSheet, Text, View, ScrollView } from 'react-native'

// styles
import { colorPalette, globalStyles } from '../static/styles/global'
import { skeletonStyles } from '../static/styles/skeleton'

// components
import Card from '../components/shared/card/Card'
import CardSeparator from '../components/shared/card/CardSeparator'
import MyScrollView from '../components/shared/navigator/MyScrollView'

const CommunicateSkeleton = () => {
  return (
    <MyScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[skeletonStyles.headerNav]} />
        <View style={[globalStyles.horizontalPadGap, globalStyles.vCenterItems, globalStyles.vDirection]}>
          <View style={[skeletonStyles.headerHeading]} />
          <View style={[skeletonStyles.headerDescription]} />
          <View style={[skeletonStyles.headerDescription]} />
        </View>
      </View>
      <View style={[globalStyles.containerOverlap]}>
        <Card>
          <View style={[styles.cardTitle]} />
          <CardSeparator light={true} />
          <View style={[globalStyles.row]}>
            <View style={[globalStyles.colFull]}>
              <View style={[styles.cardItemTitle]} />
              <View style={[styles.cardItemDescription]} />
              <View style={[styles.cardItemDescription]} />
            </View>
          </View>
        </Card>
      </View>
    </MyScrollView>
  )
}

const styles = StyleSheet.create({
  cardTitle: {
    backgroundColor: colorPalette.lightDark,
    opacity: 0.4,
    width: '50%',
    padding: 8,
    borderRadius: 10,
    marginVertical: 5
  },
  cardItemTitle: {
    backgroundColor: colorPalette.lightDark,
    opacity: 0.6,
    width: '50%',
    padding: 5,
    borderRadius: 10,
    marginVertical: 5
  },
  cardItemDescription: {
    backgroundColor: colorPalette.lightDark,
    opacity: 0.4,
    width: '70%',
    padding: 4,
    borderRadius: 10,
    marginVertical: 5
  },
  cardItemDay: {
    backgroundColor: colorPalette.lightDark,
    opacity: 0.6,
    width: '50%',
    padding: 6,
    borderRadius: 10
  },
  cardItemAvailabilty: {
    backgroundColor: colorPalette.lightDark,
    opacity: 0.4,
    width: '50%',
    padding: 20,
    borderRadius: 10,
    alignSelf: 'flex-end'
  }
})

export default CommunicateSkeleton
